import { jsx as _jsx } from "react/jsx-runtime";
export var ColorRole;
(function (ColorRole) {
    ColorRole["Default"] = "default";
    ColorRole["Primary"] = "primary";
    ColorRole["Secondary"] = "secondary";
    ColorRole["Tertiary"] = "tertiary";
    ColorRole["Success"] = "success";
    ColorRole["Info"] = "info";
    ColorRole["Warning"] = "warning";
    ColorRole["Error"] = "error";
    ColorRole["Disabled"] = "disabled";
    ColorRole["Waiting"] = "waiting";
    ColorRole["InProgress"] = "inprogress";
    ColorRole["Completed"] = "completed";
    ColorRole["Canceled"] = "canceled";
})(ColorRole || (ColorRole = {}));
export var ColorVariant;
(function (ColorVariant) {
    ColorVariant["Default"] = "default";
    ColorVariant["Accent1"] = "accent1";
    ColorVariant["Accent2"] = "accent2";
    ColorVariant["Faded1"] = "faded1";
    ColorVariant["Faded2"] = "faded2";
})(ColorVariant || (ColorVariant = {}));
export function ColorScopeClass(role) {
    return `color-scope-${role}`;
}
export function ColorScope(props) {
    const { role = ColorRole.Default, variant = ColorVariant.Default } = props;
    return (_jsx("div", { className: `context ${ColorScopeClass(role)} variant-scope-${variant}`, children: props.children }));
}
